import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';
import { api } from '@/lib/api.js';
import { PageLayout } from '@/components/layout/PageLayout.js';

type TrilhaDetail = {
  id: string;
  slug: string;
  titulo: string;
  programas: {
    id: string;
    slug: string;
    titulo: string;
    modulos: { id: string; titulo: string; aulas: { id: string; titulo: string }[] }[];
  }[];
};

export function TrilhaDetailPage() {
  const { trilhaSlug } = useParams<{ trilhaSlug: string }>();
  const q = useQuery({
    queryKey: ['trilha', trilhaSlug],
    enabled: !!trilhaSlug,
    queryFn: async () => (await api.get<TrilhaDetail>(`/conteudo/trilhas/${trilhaSlug}`)).data,
  });

  if (q.isLoading) {
    return <PageLayout title="Trilha">Carregando…</PageLayout>;
  }
  if (!q.data) {
    return (
      <PageLayout title="Trilha não encontrada">
        <Link to="/aprendizado" className="text-sm text-accent underline">
          ← Aprendizado
        </Link>
      </PageLayout>
    );
  }

  return (
    <PageLayout title={q.data.titulo}>
      <Link
        to="/aprendizado"
        className="mb-6 inline-block text-xs text-ha-muted underline hover:text-ha-text"
      >
        ← Aprendizado
      </Link>
      {q.data.programas.map((p) => (
        <section key={p.id} className="mb-8">
          <h2 className="mb-3 text-lg font-semibold text-accent">{p.titulo}</h2>
          {p.modulos.map((m) => (
            <div
              key={m.id}
              className="mb-4 rounded-element border-l-2 border-ha-border2 pl-4"
            >
              <h3 className="text-sm font-medium text-ha-subtle">{m.titulo}</h3>
              <ul className="mt-2 flex flex-col gap-1">
                {m.aulas.map((a) => (
                  <li key={a.id}>
                    <Link
                      className="text-sm text-ha-text underline decoration-ha-border hover:text-accent"
                      to={`/aprendizado/aula/${a.id}`}
                    >
                      {a.titulo}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </section>
      ))}
    </PageLayout>
  );
}
